<p-autoComplete [(ngModel)]="selectedProjectCodes" (ngModelChange)="projectCodesChange.emit($event)"
  name="selectedProjects" [disabled]="mode !== DetailMode.EDITION"
  class="project-autocomplete acted-highlight-req metadata-field" [required]="required"
  [ngClass]="(mode === 'edition' && recommended && isEmpty()) ? 'acted-highlight-recommended' : ''"
  [suggestions]="allProjectCodes" (completeMethod)="getProjectSuggestions($event)"
  [multiple]="true" [minQueryLength]="2"
  [dropdown]="false" dropdownMode="current" i18n-placeholder="@@common-none" placeholder="(none)" appendTo="body" [tabindex]="tabindex">
  <!-- define custom template for filter options -->
  <ng-template pTemplate="item" let-project>
    {{project}}
  </ng-template>
</p-autoComplete>

@if (mode === 'edition' && recommended && isEmpty() && selectedProjectCodes.length === 0) {
  <app-required-field-text/>
}
